// Первым: вкладка «Войти как игрок» подменяет хранилище до старта приложения
import './utils/impersonationBoot';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from '@sentry/react';
import './index.css';
import App from './components/app/App';
import { SiteConfigProvider } from './contexts/SiteConfigContext';
import reportWebVitals from './reportWebVitals';

// Мониторинг ошибок (Sentry SDK, совместим с GlitchTip).
// Включается только при заданном REACT_APP_SENTRY_DSN (встраивается при сборке).
const sentryDsn = process.env.REACT_APP_SENTRY_DSN ?? '';
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV,
    // Шум, который не связан с кодом сайта и забивает мониторинг:
    // кросс-документные переходы (View Transitions) со страниц входа,
    // правки DOM переводчиком браузера, ответы расширений, обрывы сети.
    // ChunkLoadError не глушим — его лечит перезагрузка в lazyWithRetry,
    // а оставшиеся случаи стоит видеть.
    ignoreErrors: [
      /Transition was (skipped|aborted)/i,
      /ViewTransition/i,
      /Failed to execute 'removeChild' on 'Node'/i,
      /Failed to execute 'insertBefore' on 'Node'/i,
      /^Method not found$/i,
      /^TypeError: Failed to fetch/i,
      /^Failed to fetch$/i,
      /NetworkError when attempting to fetch resource/i,
      /^Load failed$/i,
    ],
    denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari-(web-)?extension:\/\//i],
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/*
    <React.StrictMode>
      <App />
    </React.StrictMode>
*/

root.render(
  <Sentry.ErrorBoundary fallback={<p style={{ padding: 24, fontFamily: 'sans-serif' }}>Произошла ошибка. Обновите страницу.</p>}>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <SiteConfigProvider>
        <App />
      </SiteConfigProvider>
    </Router>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
